<div class="modal" data-id="cuf-modal" hidden>
  <div class="modal__backdrop" data-id="cuf-backdrop"></div>

  <form class="modal__dialog" data-id="cuf-form" role="dialog" aria-modal="true"
        aria-labelledby="cuf-title" novalidate>
    <header class="modal__header">
      <h2 class="modal__title" id="cuf-title" data-id="cuf-title-text"><%= _lcs( 'Neuen Client anlegen' ) %></h2>
      <button type="button" class="iconbtn modal__close" data-id="cuf-close" aria-label="<%= _lcs( 'Schließen' ) %>">
        <i class="icon icon--x"></i>
      </button>
    </header>

    <div class="modal__body">
      <div class="field">
        <label class="field__label" for="cuf-name"><%= _lcs( 'Name' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--user"></i></span>
          <input class="field__input" id="cuf-name" name="name" type="text"
                 autocomplete="name" placeholder="<%= _lcs( 'Max Mustermann' ) %>" required
                 data-msg-required="<%= _lcs( 'Bitte gib einen Namen ein.' ) %>" />
        </div>
      </div>

      <div class="field">
        <label class="field__label" for="cuf-company"><%= _lcs( 'Firmenname' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--building-2"></i></span>
          <input class="field__input" id="cuf-company" name="companyName" type="text"
                 autocomplete="organization" placeholder="<%= _lcs( 'Musterhotel GmbH' ) %>" required
                 data-msg-required="<%= _lcs( 'Bitte gib einen Firmennamen ein.' ) %>" />
        </div>
      </div>

      <div class="field">
        <label class="field__label" for="cuf-email"><%= _lcs( 'E-Mail' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--mail"></i></span>
          <input class="field__input" id="cuf-email" name="email" type="email"
                 inputmode="email" autocomplete="off" placeholder="name@belturo.com" required
                 data-msg-required="<%= _lcs( 'Bitte gib eine E-Mail-Adresse ein.' ) %>" />
        </div>
      </div>

      <div class="field">
        <label class="field__label" for="cuf-password"><%= _lcs( 'Passwort' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--lock"></i></span>
          <input class="field__input" id="cuf-password" name="password" type="password"
                 autocomplete="new-password" placeholder="<%= _lcs( 'Mindestens 6 Zeichen' ) %>" minlength="6" required
                 data-msg="<%= _lcs( 'Das Passwort muss mindestens 6 Zeichen lang sein.' ) %>" />
        </div>
      </div>

      <div class="field">
        <label class="field__label" for="cuf-status"><%= _lcs( 'Status' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--heart-pulse"></i></span>
          <select class="field__input field__select" id="cuf-status" name="status">
            <option value="ok" selected><%= _lcs( 'Aktiv' ) %></option>
            <option value="not_validated"><%= _lcs( 'Nicht verifiziert' ) %></option>
            <option value="blocked"><%= _lcs( 'Gesperrt' ) %></option>
            <option value="banned"><%= _lcs( 'Gebannt' ) %></option>
          </select>
        </div>
      </div>

      <p class="field__note">
        <i class="icon icon--shield-check"></i>
        <%= _lcs( 'Rolle:' ) %> <strong>Client</strong> <%= _lcs( '(Gastgeber-Zugang)' ) %>
      </p>

      <p class="modal__error" data-id="cuf-error" role="alert" hidden></p>
    </div>

    <footer class="modal__footer">
      <button type="button" class="btn btn--ghost btn--sm" data-id="cuf-cancel"><%= _lcs( 'Abbrechen' ) %></button>
      <button type="submit" class="btn btn--primary btn--sm" data-id="cuf-submit">
        <span data-id="cuf-submit-label"><%= _lcs( 'Anlegen' ) %></span>
        <i class="icon icon--arrow-right"></i>
      </button>
    </footer>
  </form>
</div>
